module.exports = __webpack_public_path__ + "media/images/icons/zoom-out-e4606674e9142ea00bfe49f1011f501e.svg";